import TaskFields from "../../model2/task/task-fields"
import TimeReportFields from "../../model2/time-report/fields"
import FieldProto from "../../fields3/proto/field-proto"
import EventFields from "../../model2/event/event-fields"
import ProjectFields from "../../model2/project/project-fields"
import CompanyUserFields from "../../model2/company-user-new/fields"
import ExpenseFields from "../../model2/expenses/expense/fields"
import RecurrenceFields from "../../model2/recurrence/fields"
import NotepadFields from "../../model2/notepad/fields"
import EmailTemplateFields from "../../model2/email-template/fields"
import MeetingFields from "../../model2/meeting/fields"
import ItemModelFields from "../../model2/item/fields"
import GoalFields from "../../model2/goal/fields"
import TimeCostHistoryFields from "../../model2/hour-cost/hourly-rate-history/fields"
import OfficeFields from "../../model2/office/fields"
import AttendanceFields from "../../model2/attendance-event/fields"
import ProjectPropertiesFields from "../../model2/project/properties/fields"
import WorkWeekScheduleFields from "../../model2/work-week-schedule/work-week-schedule-fields"
import ProjectViewFields from "../../model2/project-view/fields";
import SupportTicketFields from "../../model2/support-ticket/fields"
import ExternalEntityFields from "../../model2/custom-entity/fields"
import ExpenseCategoryFields from "../../model2/expenses/expense-category/fields"
import globalFields_getDynamicField from "./actions/get-dynamic-field"
import ReportFields from "../../model2/report/fields"
import SavedViewsFields from "../../model2/saved-view/fields";

const debug = false
// const debug = "GlobalFields"

export default class GlobalFields {

    public task                 : TaskFields                = new TaskFields()
    public event                : EventFields               = new EventFields()
    public timeReport           : TimeReportFields          = new TimeReportFields()
    public project              : ProjectFields             = new ProjectFields()
    public companyUser          : CompanyUserFields         = new CompanyUserFields()
    public recurrence           : RecurrenceFields          = new RecurrenceFields()
    public notepad              : NotepadFields             = new NotepadFields()
    public emailTemplate        : EmailTemplateFields       = new EmailTemplateFields()
    public meeting              : MeetingFields             = new MeetingFields()
    public itemModel            : ItemModelFields           = new ItemModelFields()
    public goal                 : GoalFields                = new GoalFields()
    public timeCostHistory      : TimeCostHistoryFields     = new TimeCostHistoryFields()
    public office               : OfficeFields              = new OfficeFields()
    public attendance           : AttendanceFields          = new AttendanceFields()
    public projectProperties    : ProjectPropertiesFields   = new ProjectPropertiesFields()
    public projectView          : ProjectViewFields         = new ProjectViewFields()
    public workWeekSchedule     : WorkWeekScheduleFields    = new WorkWeekScheduleFields()
    public supportTicket        : SupportTicketFields       = new SupportTicketFields()
    public externalEntity       : ExternalEntityFields      = new ExternalEntityFields()
    public reportFields         : ReportFields              = new ReportFields()
    public savedView            : SavedViewsFields          = new SavedViewsFields()

    public expense              : ExpenseFields             = new ExpenseFields()
    public expenseCategory      : ExpenseCategoryFields     = new ExpenseCategoryFields()

    onNewCustomField(customField: any) {
        this.task.addCustomField(customField)
        this.project.addCustomField(customField)
    }

    getBySystemFieldId(systemFieldId:string):FieldProto|null {

        if (!systemFieldId) return null

        const parts : string[] = systemFieldId.split('.')

        const entityPrefix:string   = parts[0]
        const fieldId:string        = parts[1]

        switch (entityPrefix) {
            case 'task':
                return this.task.get(fieldId)
            case 'event':
                return this.event.get(fieldId)
            case 'project':
                return this.project.get(fieldId)
            case 'expense':
                return this.expense.get(fieldId)
            case 'timeReport':
                return this.timeReport.get(fieldId)
            case 'itemModel':
                return this.itemModel.get(fieldId)
            case 'dynamic': // custom fields
                return globalFields_getDynamicField(fieldId)
        }

        console.error("ERROR GlobalFields.getBySystemFieldId-1 Unknown system field = ", systemFieldId)

        return null



    }

    resetAll() {
        this.task               = new TaskFields()
        this.event              = new EventFields()
        this.timeReport         = new TimeReportFields()
        this.project            = new ProjectFields()
        this.companyUser        = new CompanyUserFields()
        this.recurrence         = new RecurrenceFields()
        this.notepad            = new NotepadFields()
        this.emailTemplate      = new EmailTemplateFields()
        this.meeting            = new MeetingFields()
        this.itemModel          = new ItemModelFields()
        this.goal               = new GoalFields()
        this.timeCostHistory    = new TimeCostHistoryFields()
        this.office             = new OfficeFields()
        this.attendance         = new AttendanceFields()
        this.projectProperties  = new ProjectPropertiesFields()
        this.projectView        = new ProjectViewFields()
        this.workWeekSchedule   = new WorkWeekScheduleFields()
        this.supportTicket      = new SupportTicketFields()
        this.externalEntity     = new ExternalEntityFields()
        this.reportFields       = new ReportFields()
        this.savedView          = new SavedViewsFields()

        this.expense            = new ExpenseFields()
        this.expenseCategory    = new ExpenseCategoryFields()
    }

    resetCurrencyFields = () => {

        // Why ? hm...
        // below collections contain FieldType.CURRENCY which need to be updated (currency icon)
        this.task       = new TaskFields()
        this.timeReport = new TimeReportFields()
        this.expense    = new ExpenseFields()
    }

    resetTagsFields = () => {
        // below collections contain FieldType.TASK_TAGS which need to be updated
        this.task       = new TaskFields()
        this.event      = new EventFields()

        debug && console.log(debug, 'resetTagsFields', gd.fields.task.tags)
    }
}
